import { RouterProvider, createBrowserRouter } from "react-router-dom"
import { Auth } from "./Auth/auth";
import { Pages } from "./Pages/pages";

const router = createBrowserRouter([Auth,Pages]);

export default function Router(){
    return <RouterProvider router={router}/>
}